import React from "react";

interface Booking {
  title: string;
  start: Date;
  end: Date;
  deliveryMethod?: string;
}

interface Props {
  bookings: Booking[];
}

const TomorrowLogistics = ({ bookings }: Props) => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  const isSameDate = (date1: Date, date2: Date) =>
    date1.toDateString() === date2.toDateString();

  const deliveries = bookings.filter(
    (b) =>
      b.deliveryMethod &&
      ["Tur/Retur", "Vi leverer"].includes(b.deliveryMethod) &&
      isSameDate(b.start, tomorrow)
  );

  const pickups = bookings.filter(
    (b) =>
      b.deliveryMethod &&
      ["Tur/Retur", "Vi henter"].includes(b.deliveryMethod) &&
      isSameDate(b.end, tomorrow)
  );

  return (
    <div>
      <h2 className="text-xl font-bold text-[#1B4E8C] mb-4">
        Morgendagens Leveringer & Hentinger
      </h2>
      {deliveries.length === 0 && pickups.length === 0 && (
        <p className="text-gray-500">
          Ingen leveringer eller hentinger i morgen.
        </p>
      )}

      {deliveries.length > 0 && (
        <div className="mb-4">
          <h3 className="font-semibold text-[#1B4E8C] mb-2">Leveringer</h3>
          <ul className="list-disc list-inside">
            {deliveries.map((b, i) => (
              <li key={i}>{b.title}</li>
            ))}
          </ul>
        </div>
      )}

      {pickups.length > 0 && (
        <div>
          <h3 className="font-semibold text-[#1B4E8C] mb-2">Hentinger</h3>
          <ul className="list-disc list-inside">
            {pickups.map((b, i) => (
              <li key={i}>{b.title}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default TomorrowLogistics;
